// Resolves the parent schedule + occurrence-period label for a
// deliverable, used by DeliverableDetailExpand to disambiguate a
// recurring child's header ("Monthly Service Report — Apr 2026"
// instead of just "Monthly Service Report"). Returns an empty
// object when the deliverable isn't a child or its parent can't be
// resolved — the consumer treats both legs as the no-disambiguation
// case.

import { deriveOccurrenceTitle } from "./deriveOccurrenceTitle";
import type { Deliverable } from "../../../../types";

export interface OccurrenceContext {
  parent?: Deliverable;
  occurrenceTitle?: string;
}

export function lookupOccurrenceContext(
  deliverable: Deliverable,
  pool: readonly Deliverable[],
): OccurrenceContext {
  if (!deliverable.parentId) return {};
  const parent = pool.find((d) => d.id === deliverable.parentId);
  if (!parent) return {};
  return {
    parent,
    occurrenceTitle: deriveOccurrenceTitle(deliverable, parent),
  };
}
